export const descriptionForCsp = (pageDetector, customSearch, pageHeader, page) => {
  if (!customSearch) return ''
  const description = customSearch.meta_description || ''
  if (!pageDetector.isFirstPage) {
    const customSearchName = customSearch.name || ''
    let title
    if (customSearchName) {
      title = pageDetector.isSingleCustomSearchPage ? `${customSearchName}の街コン・出会い` : `${customSearchName}の街コン（全イベント）`
    } else {
      title = pageDetector.isSingleCustomSearchPage ? '街コン・出会い' : '街コン（全イベント）'
    }
    return `【${title}-${page}ページ目】${description}`
  }
  if (description && (pageDetector.isAreasCustomSearchPage || pageDetector.isRegionsCustomSearchPage || pageDetector.isAreasAreaCustomSearchPage)) {
    return `【${pageHeader}】${description}`
  }
  return description
}
